import { render, staticRenderFns } from "./CommandPalette.vue?vue&type=template&id=6bd957a0&scoped=true"
import script from "./CommandPalette.vue?vue&type=script&lang=ts"
export * from "./CommandPalette.vue?vue&type=script&lang=ts"
import style0 from "./CommandPalette.vue?vue&type=style&index=0&id=6bd957a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd957a0",
  null
  
)

export default component.exports